

window.addEventListener('load', function () {
    document.querySelectorAll('.collection .product').forEach(function (product) {
        if (product.querySelector('.sold-out-badge')) {
            product.classList.add('sold-out');
            product.classList.remove('sale');
        } else {
            product.classList.add('sale');
            product.classList.remove('sold-out');
        }
    });
});

